import { ComponentProps, FC, useState } from "react";

import Modal from "containers/Shared/Modal/Modal";
import { ILayoutProps } from "modules";

import classNames from "classnames";

type ContentType = {
  headerProps?: ComponentProps<typeof Modal>["headerProps"];
  shouldCloseOverlay?: boolean;
  onClose?: () => void;
  onOverlayClickAndEsc?: () => void;
};

const OverlayLayout: FC<ILayoutProps<ContentType>> = props => {
  const { children, className } = props;
  const content = props.content as ContentType;
  const shouldCloseOverlay = content?.shouldCloseOverlay;
  const classes = classNames("overlay-layout", className);

  // LOCAL STATE
  const [isManuallyClosed, setIsManuallyClosed] = useState(false);

  const isOpen = !isManuallyClosed && !shouldCloseOverlay;

  // METHODS
  const handleOnClose = () => {
    setIsManuallyClosed(true);
    content?.onClose && content.onClose();
  };

  const onOverlayClickAndEsc = () => {
    content?.onOverlayClickAndEsc && content.onOverlayClickAndEsc();
    handleOnClose();
  };

  // RENDER
  return (
    <Modal
      className={classes}
      headerProps={content?.headerProps}
      isOpen={isOpen}
      onClose={onOverlayClickAndEsc}
      type="default">
      <div className="modal__container" data-testid="dynamic-form-layout__modal">
        {children}
      </div>
    </Modal>
  );
};

export default OverlayLayout;
